import { render, staticRenderFns } from "./HowToSizeWeight.vue?vue&type=template&id=f690982e&scoped=true"
import script from "./HowToSizeWeight.vue?vue&type=script&lang=js"
export * from "./HowToSizeWeight.vue?vue&type=script&lang=js"
import style0 from "./HowToSizeWeight.vue?vue&type=style&index=0&id=f690982e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f690982e",
  null
  
)

export default component.exports